import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/main-menu.module.css";
import { Language, MainMenuItem, PageState } from "../types/index.js";
import MainMenuLevelLeftNav from "./MainMenuLevelLeftNav.js";

interface Props {
  menuItems: MainMenuItem[];
  isPreview: boolean;
  pages: PageState;
  languageId: Language;
  menuLevel: number;
  activePagePath: string[];
  fallbackLanguageId: Language | undefined;
  onMenuItemClick: () => void;
}

const MainMenuListLeftNav: FunctionComponent<Props> = ({
  menuItems,
  isPreview,
  languageId,
  pages,
  menuLevel,
  activePagePath,
  fallbackLanguageId,
  onMenuItemClick,
}) =>
  !menuItems.length ? null : (
    <ul
      className={ClassNames(styles.MainMenu__List, {
        [styles["MainMenu__List--level1"]]: menuLevel === 1,
        [styles["MainMenu__List--level2up"]]: menuLevel >= 2,
      })}
    >
      {menuItems.map((currentMenuItem) => (
        <MainMenuLevelLeftNav
          key={currentMenuItem.id}
          currentMenuItem={currentMenuItem}
          isPreview={isPreview}
          languageId={languageId}
          parentId={currentMenuItem.id}
          pages={pages}
          menuLevel={menuLevel}
          activePagePath={activePagePath}
          fallbackLanguageId={fallbackLanguageId}
          onMenuItemClick={onMenuItemClick}
        />
      ))}
    </ul>
  );
export default MainMenuListLeftNav;
